import { RefiIdpTokenRefresh } from './idp-token-refresh.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../utils/track-analytics-event.js';

defineRefiElement('refi-common-idp-token-refresh', RefiIdpTokenRefresh);
